export const config = {
  serverMaintenance: false, // Set to true to enable server maintenance mode
};
